import { parseMarkdown } from '@/lib/markdown';

/**
 * A published document, rendered.
 *
 * The body is escaped in `parseMarkdown` before any markup is applied, so
 * `dangerouslySetInnerHTML` here carries only the bold and code spans that
 * function produced. It is used per block rather than on the whole document so
 * that the spacing is React's and only the inline runs are HTML. R-194.
 */
export function Prose({ source }: { source: string }) {
  const blocks = parseMarkdown(source);

  return (
    <article className="max-w-[70ch] text-[14px] leading-[1.6]">
      {blocks.map((b, i) => {
        const key = `${b.kind}-${i}`;
        if (b.kind === 'h1') {
          return (
            <h2 key={key} className="mb-3 mt-7 text-[18px] font-semibold first:mt-0">
              <span dangerouslySetInnerHTML={{ __html: b.html! }} />
            </h2>
          );
        }
        if (b.kind === 'h2') {
          return (
            <h3 key={key} className="mb-2 mt-6 text-[15px] font-semibold first:mt-0">
              <span dangerouslySetInnerHTML={{ __html: b.html! }} />
            </h3>
          );
        }
        if (b.kind === 'h3') {
          return (
            <h4 key={key} className="mb-2 mt-5 text-[13px] font-semibold uppercase tracking-[0.04em] text-muted first:mt-0">
              <span dangerouslySetInnerHTML={{ __html: b.html! }} />
            </h4>
          );
        }
        if (b.kind === 'ol') {
          return (
            <ol key={key} className="mb-4 ml-5 list-decimal space-y-1.5 marker:text-muted">
              {b.items!.map((html, j) => (
                <li key={j} className="pl-1" dangerouslySetInnerHTML={{ __html: html }} />
              ))}
            </ol>
          );
        }
        if (b.kind === 'ul') {
          return (
            <ul key={key} className="mb-4 ml-5 list-disc space-y-1.5 marker:text-muted">
              {b.items!.map((html, j) => (
                <li key={j} className="pl-1" dangerouslySetInnerHTML={{ __html: html }} />
              ))}
            </ul>
          );
        }
        return (
          <p key={key} className="mb-3.5" dangerouslySetInnerHTML={{ __html: b.html! }} />
        );
      })}
    </article>
  );
}
